import { FC, useState } from 'react';
import { AuthRegisterForm } from '../components/AuthRegisterForm';
import { Formik } from 'formik';
import { RegisterFormValues } from '../types';
import { authFormValidSchema } from '../utils/authFormValidSchema';
import { RegisterSuccessBox } from '../components/RegisterSuccessBox';
import { postRegisterApi } from '../web-api/api';
import { SecurityLayout } from 'gtx-react/components/Security/SecurityLayout';

export const AuthRegisterView: FC = () => {
    const [showSuccessBox, setShowSuccessBox] = useState<boolean>(false);
    const [errorBoxMsg, setErrorBoxMsg] = useState<string | null>(null);

    return (
        <SecurityLayout>
            <div className="login-content login-content--register">
                {showSuccessBox ? (
                    <RegisterSuccessBox />
                ) : (
                    <Formik
                        initialValues={
                            {
                                tipoimpresa: '0',
                                nome: '',
                                cognome: '',
                                nomesocieta: '',
                                email: '',
                                idComune: null,
                                telefono: '',
                                prefisso: {
                                    callingCode:
                                        window.gtxConstants
                                            .DEFAULT_CONTACT_INTERNATIONAL_PREFIX,
                                    shortCode:
                                        window.gtxConstants
                                            .DEFAULT_CONTACT_NUMBER_SHORT_CODE,
                                },
                                privacy: false,
                                piva: '',
                            } as RegisterFormValues
                        }
                        validateOnMount={false}
                        validateOnBlur={false}
                        validateOnChange={false}
                        onSubmit={(values) => {
                            return postRegisterApi(values)
                                .then(() => {
                                    setShowSuccessBox(true);
                                    setErrorBoxMsg(null);
                                })
                                .catch((error: Error) => {
                                    setErrorBoxMsg(error.message);
                                });
                        }}
                        validationSchema={authFormValidSchema}
                    >
                        <AuthRegisterForm errorBox={errorBoxMsg} />
                    </Formik>
                )}
            </div>
        </SecurityLayout>
    );
};
